import React from "react";

const AdmissionSection = ({ formData, setFormData }) => {
  return (
    <section className="form-section">
      <h3>4-1. 입원</h3>

      {/* DNR 작성여부 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">DNR 작성여부</label>
          <div className="input_2col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="DNR"
                  value={value}
                  checked={formData.DNR === value}
                  onChange={(e) =>
                    setFormData({ ...formData, DNR: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>

      {/* TTM 시행 및 온도 설정 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">TTM 시행</label>
          <div className="input_2col">
            {["Hypothermia", "Normothermia", "시행하지 않음"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="TTM"
                  value={value}
                  checked={formData.TTM === value}
                  onChange={(e) =>
                    setFormData({ ...formData, TTM: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">TTM 초기 설정 온도</label>
          <div className="input-with-unit">
            <input
              type="text"
              id="TTM_temp"
              value={formData.TTM_temp || ""}
              onChange={(e) =>
                setFormData({ ...formData, TTM_temp: e.target.value })
              }
            />
            <span className="unit-text">℃</span>
          </div>
        </div>
      </div>

      {/* TTM 미시행 사유 */}
      {formData.TTM === "시행하지 않음" && (
        <div className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">TTM 미사유</label>
            <div className="input_1col">
              {["Obey command", "보호자 거부", "Hopless", "Others"].map(
                (value) => (
                  <label key={value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="TTM_reason"
                      value={value}
                      checked={formData.TTM_reason === value}
                      onChange={(e) =>
                        setFormData({ ...formData, TTM_reason: e.target.value })
                      }
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{value}</div>
                  </label>
                )
              )}
            </div>
          </div>
        </div>
      )}

      {/* Others 선택 시 나타나는 텍스트 필드 */}
      {formData.TTM === "시행하지 않음" && formData.TTM_reason === "Others" && (
        <div className="input-wrapper-1column">
          <div className="block-1column">
            <label className="item_title_1col">TTM 미사유 기타 사항</label>
            <div className="input_1col">
              <input
                type="text"
                value={formData.TTM_others_text_input || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    TTM_others_text_input: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
      )}

      {/* ECMO 및 CRRT 시행 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">CPR 후 ECMO 시행</label>
          <div className="input_2col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="ECMO"
                  value={value}
                  checked={formData.ECMO === value}
                  onChange={(e) =>
                    setFormData({ ...formData, ECMO: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">CRRT시행</label>
          <div className="input_2col">
            {["예", "아니오"].map((value) => (
              <label key={value} className="rad-label">
                <input
                  type="radio"
                  className="rad-input"
                  name="CRRT"
                  value={value}
                  checked={formData.CRRT === value}
                  onChange={(e) =>
                    setFormData({ ...formData, CRRT: e.target.value })
                  }
                />
                <div className="rad-design"></div>
                <div className="rad-text">{value}</div>
              </label>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdmissionSection;
